/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { ArticleOutlined } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Box, Divider, Link, Stack, Toolbar, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { saveAs } from 'file-saver';
import { Outlet, useParams } from 'react-router-dom';

import { downloadCompareDocx } from '../../axiosClient/draftApi';
import { IMenuOption } from '../../interfaces/IMenuOption';
import DropdownButton from '../DropdownButton';

const downloadMenu: IMenuOption[] = [
  {
    value: 'excel',
    label: 'Excel',
    startIcon: <ArticleOutlined />,
  },
];

const DraftLayout = () => {
  const { id } = useParams();
  const { mutate: getExcelMutation } = useMutation({
    mutationKey: ['compare-data-points'],
    mutationFn: downloadCompareDocx,
    onSuccess: (response) => {
      saveAs(response, `compare-${Date.now()}.xlsx`);
    },
  });

  const handleDownload = React.useCallback(() => {
    getExcelMutation({ compare_draft: id, type: 'excel' });
  }, []);

  return (
    <Box>
      <Box>
        <Toolbar>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <Link
                href="/drafts"
                color="riPrimary.500"
                underline="hover"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <ArrowBackIcon fontSize="small" sx={{ marginRight: '2px' }} />
                Close
              </Link>
            </Box>
            <Stack
              direction="row"
              alignItems="center"
              flex={1}
              justifyContent="center"
            >
              <Typography
                marginRight={4}
                fontSize="16px"
                fontWeight="500"
                whiteSpace="nowrap"
              >
                Compare Drafts
              </Typography>
            </Stack>
            <Stack direction="row" flex={1} justifyContent="flex-end">
              <DropdownButton
                options={downloadMenu}
                startIcon={<SaveAltIcon />}
                menuHeader="Download as:"
                buttonName="Download"
                handleDropdownChange={handleDownload}
              />
            </Stack>
          </Stack>
        </Toolbar>
        <Divider />
      </Box>
      <Box
        sx={{
          padding: '10px 15px 0',
          overflow: 'auto',
          height: '84vh',
        }}
      >
        <main>
          <Outlet />
        </main>
      </Box>
    </Box>
  );
};

export default DraftLayout;
